// Entry point for the build script in your package.json
import "./controllers"
import Plyr from "plyr";
window.Plyr = Plyr
import * as bootstrap from "bootstrap"

window.setPwToggler = function setPwToggler(pwfield, togglebtn) {
    if(pwfield) {
        togglebtn.addEventListener('click', function () {
            if (pwfield.type === "password") {
                pwfield.type = "text";
                togglebtn.classList.replace("bi-eye", "bi-eye-slash");
            } else {
                pwfield.type = "password";
                togglebtn.classList.replace("bi-eye-slash", "bi-eye");
            }
        });
    }
}

setPwToggler(document.getElementById('password'), document.getElementById('togglePassword'));
setPwToggler(document.getElementById('password2'), document.getElementById('togglePassword2'));